import React from 'react';
import { Message } from 'semantic-ui-react';

const messages = ({ messages, errors }) => {
  const messagesAsList = (_messages) => {
    return _messages.map(({ message, validations, index }) => {
      if (validations) {
        const validationItems = validations.map(({ message, index }) => {
          return <Message.Item key={`message${index}`}>{message}</Message.Item>;
        });

        return (
          <Message.Item key={`message${index}`}>
            {message}
            <Message.List>{validationItems}</Message.List>
          </Message.Item>
        );
      }

      return <Message.Item key={`message${index}`}>{message}</Message.Item>;
    });
  };

  if (messages !== undefined && messages.length > 0) {
    return (
      <Message>
        <Message.List>{messagesAsList(messages)}</Message.List>
      </Message>
    );
  }
  if (errors !== undefined && errors.length > 0) {
    return (
      <Message negative>
        <Message.List>{messagesAsList(errors)}</Message.List>
      </Message>
    );
  }

  return null;
};

export default messages;



// WEBPACK FOOTER //
// ./src/components/Messages.js